import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../../../init-store';

type ChatState = {
    chatUnreadCount: number;
    chatId: string | null;
    isLoading: boolean;
    authUserChanged?: boolean;
    chatUserGuid: string | null;
    isChatWidgetReady: boolean;
    joinedChatId: Maybe<string>;
    chatHistory?: string;
    showChatRecordNotification?: boolean;
};

const initialState: ChatState = {
    chatUnreadCount: 0,
    chatId: null,
    isLoading: false,
    chatUserGuid: null,
    isChatWidgetReady: false,
    joinedChatId: undefined,
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setIsChatLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setChatUnreadCount(state, action: PayloadAction<number>) {
            state.chatUnreadCount = action.payload;
        },
        setChatId(state, action: PayloadAction<string | null>) {
            state.chatId = action.payload;
        },
        setChatUserGuid(state, action: PayloadAction<string>) {
            state.chatUserGuid = action.payload;
        },
        setIsChatWidgetReady(state, action: PayloadAction<boolean>) {
            state.isChatWidgetReady = action.payload;
        },
        setJoinedChatId(state, action: PayloadAction<Maybe<string>>) {
            state.joinedChatId = action.payload;
        },
        closeChatRecordNotification(state, action: PayloadAction<boolean>) {
            state.showChatRecordNotification = action.payload;
        },
        setChatHistory(state, action: PayloadAction<string>) {
            state.chatHistory = action.payload;
        },
        setChatAuthUserChanged(state, action: PayloadAction<boolean>) {
            state.authUserChanged = action.payload;
        },
        resetChatState() {
            return initialState;
        },
    },
});
export const exportChatHistorySavedAction = createAction<void>('conference/chat/exportChatHistorySavedAction');
export const joiningTheChatAction = createAction('conference/chat/userJoiningToChat');
export const createChatAction = createAction('conference/chat/createChat');
export const setOnlineInChatAction = createAction('conference/chat/setOnlineInChat');
export const toggleChatVisibilityAction = createAction<boolean>('conference/chat/toggleChatVisibility');

export const {
    setIsChatLoading,
    setChatUnreadCount,
    setChatId,
    setChatUserGuid,
    setIsChatWidgetReady,
    setJoinedChatId,
    closeChatRecordNotification,
    setChatHistory,
    setChatAuthUserChanged,
    resetChatState,
} = chatSlice.actions;

export const getIsChatLoading = (state: RootState) => {
    return state.call.chat.isLoading;
};
export const getChatUnreadCount = (state: RootState) => {
    return state.call.chat.chatUnreadCount;
};

export const getChatUserGuid = (state: RootState) => state.call.chat.chatUserGuid;

export const getIsChatWidgetReady = (state: RootState) => {
    return state.call.chat.isChatWidgetReady;
};

export const getIsChatUserJoined = (state: RootState) => {
    return Boolean(state.call.chat.joinedChatId);
};

export const getJoinedChatId = (state: RootState) => state.call.chat.joinedChatId;

export const getChatHistory = (state: RootState) => {
    return state.call.chat.chatHistory || '';
};
export const getChatAuthUserChanged = (state: RootState) => {
    return state.call.chat.authUserChanged;
};

export const chatReducer = chatSlice.reducer;
